import { render } from "./Compagion.vue?vue&type=template&id=4f52feef&scoped=true"
import script from "./Compagion.vue?vue&type=script&lang=js"
export * from "./Compagion.vue?vue&type=script&lang=js"

import "./Compagion.vue?vue&type=style&index=0&id=4f52feef&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f52feef"]])

export default __exports__